__turbopack_context__.v({
  "container": "UltrasignalSection-module__lODKua__container",
  "contentContainer": "UltrasignalSection-module__lODKua__contentContainer",
  "ctaContainer": "UltrasignalSection-module__lODKua__ctaContainer",
  "fadeIn": "UltrasignalSection-module__lODKua__fadeIn",
  "heading": "UltrasignalSection-module__lODKua__heading",
  "iframeContainer": "UltrasignalSection-module__lODKua__iframeContainer",
  "mediaContainer": "UltrasignalSection-module__lODKua__mediaContainer",
  "primaryButton": "UltrasignalSection-module__lODKua__primaryButton",
  "root": "UltrasignalSection-module__lODKua__root",
  "subtitle": "UltrasignalSection-module__lODKua__subtitle",
  "textContent": "UltrasignalSection-module__lODKua__textContent",
  "tfModal": "UltrasignalSection-module__lODKua__tfModal",
});
